import {Inject, Injectable} from '@angular/core';
import { SecureApi } from '../../core/secure.api';

@Injectable()
export class MePaymentService {
    articleType = 'Map';
    couponCode = '';

    constructor(
       private secureApi : SecureApi
    ) {

    }

    getPaymentInfo(type) {
        return this.secureApi.get('b2c-patients/get-payment-info/' + type);
    }

    checkCoupon(data) {
        // To do check coupon
        return this.secureApi.post('b2c-patients/check-coupon-valid', data, false);
    }

    createPayment(data) {
        return this.secureApi.post('b2c-payments/create', data, false);
    }

    checkPayment(id) {
        return this.secureApi.get('b2c-payments/check-payment/' + id);
    }

    getBillingAddress() {
        return this.secureApi.get('b2c-payments/billing-address');
    }
}
